const Coinbase = () => (
  <svg fill='none' viewBox='0 0 32 32'>
    <circle cx='16' cy='16' r='16' fill='#fff' />
    <circle cx='16' cy='16' r='9' fill='#0052FF' />
    <path
      fill='#fff'
      d='M16.011 19a3.002 3.002 0 0 1-3.005-3c0-1.658 1.345-3 3.005-3a3.003 3.003 0 0 1 2.96 2.5H22a6.006 6.006 0 0 0-5.989-5.5C12.693 10 10 12.688 10 16c0 3.313 2.693 6 6.011 6A6.007 6.007 0 0 0 22 16.5h-3.03a3 3 0 0 1-2.96 2.5Z'
    />
  </svg>
)

export { Coinbase }
